import React, { useEffect } from "react";
import User from "./Users/User";

const UsersAndTeams = () => {
  return (
    <>
      <div className="dashboardWrp">
        <div className="uk-container uk-container-large">
          <div className="dashboardTop">
            <div uk-grid="" className="uk-grid uk-grid-small">
              <div className="uk-width-2-3">
                <div className="dashboardIntro">
                  {/* <h3>USERS AND TEAMS</h3> */}
                  <h3>USERS</h3>
                  <p>
                    Use this page to create new and manage current users and
                    teams.
                  </p>
                </div>
              </div>
              {/* <div className="uk-width-1-3">
                <div className="dashboardIntro uk-text-right">
                  <button>EXPORT DATA</button>
                </div>
              </div> */}

              <div className="uk-width-1-1 ">
                <ul
                  className="uk-subnav callSwitcher"
                  uk-switcher="connect: .callClass"
                >
                  <li>
                    <a href="#">Users</a>
                  </li>
                  {/* <li>
                    <a href="#">Teams</a>
                  </li> */}
                </ul>
              </div>
            </div>
            <ul className="uk-switcher uk-margin callClass">
              <li>
                <User />
              </li>
              {/* <li>
                <Teams/>
              </li> */}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default UsersAndTeams;
